module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/phand5-13304c55ebe84f4570afc399baf0f9ca.jpg";